import React from 'react';
import Slider from 'rc-slider';
import 'rc-slider/assets/index.css';

export default function InputSlider(props) {
    return <Slider {...props}></Slider>
}